import type { MultiLingualField } from "@/models/misc";

export enum MembershipTierPlanFrequency {
  MONTH = "month",
  YEAR = "year",
}

export type MembershipTierPlan = {
  id: number;
  membershipTierId: number;
  frequency: MembershipTierPlanFrequency;
  price: number;
  hidden: boolean;
  chipText: MultiLingualField | null;
  createdAt: string;
  updatedAt: string;
}
